import { getApplication } from './Application';

export const getExperiments = (): string[] => {
  const application = getApplication();
  return application ? application.get('experiments') : [];
};
